// Hides the sticky header while the visitor scrolls down and reveals it on any scroll up.
// Stays visible near the top of the page, while focus is inside it, or while one of its menus is open.
class HideOnScroll extends HTMLElement {
  #abort = null;
  #lastY = 0;
  #frame = 0;

  connectedCallback() {
    this.#abort = new AbortController();
    this.#lastY = window.scrollY;
    window.addEventListener('scroll', () => {
      if (this.#frame) return;
      this.#frame = window.requestAnimationFrame(() => {
        this.#frame = 0;
        this.#update();
      });
    }, { passive: true, signal: this.#abort.signal });
    this.addEventListener('focusin', () => this.#show(), { signal: this.#abort.signal });
  }

  disconnectedCallback() {
    this.#abort?.abort();
    window.cancelAnimationFrame(this.#frame);
  }

  #update() {
    const y = Math.max(window.scrollY, 0);
    const delta = y - this.#lastY;
    if (Math.abs(delta) < 6) return;
    const busy = this.matches(':focus-within') || this.querySelector('details[open], dialog[open], :popover-open');
    if (delta > 0 && y > this.offsetHeight && !busy) this.toggleAttribute('data-hidden', true);
    else if (delta < 0) this.#show();
    this.#lastY = y;
  }

  #show() {
    this.removeAttribute('data-hidden');
  }
}

if (!customElements.get('s-hide-on-scroll')) customElements.define('s-hide-on-scroll', HideOnScroll);
